// extracted by mini-css-extract-plugin
export default {"btn":"Tab_btn__O3t7R","active":"Tab_active__Nq2Ym"};